export const STATIC_EXCEPTION_CATEGORY = 'StaticException';

export class StaticException extends Error {
	constructor(m: string) {
		super(m);

		this.name = STATIC_EXCEPTION_CATEGORY;
		Object.setPrototypeOf(this, StaticException.prototype);
	}
}
